import ScheduleEditingPage from "./ScheduleEditingPage";

export default ScheduleEditingPage;
